// Cliente Supabase — inicializado a partir das variáveis de ambiente (.env).
// As VITE_* são injetadas pelo Vite em tempo de build.
import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anonKey) {
  console.warn(
    '[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY ausentes. ' +
    'Defina-os no arquivo .env (veja .env.example).'
  )
}

export const supabase = createClient(url ?? '', anonKey ?? '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

export const PANEL_EMAIL = import.meta.env.VITE_PANEL_EMAIL ?? ''
